<template>
    <div class="avatar-form">
        <div class="picture">
            <img class="border w-100 h-100 rounded-circle" :src="avatar" :alt="user.full_name">
        </div>
        <div class="mt-2">
            <form method="POST" enctype="multipart/form-data">
                <image-upload name="avatar" @loaded="onLoad"></image-upload>
            </form>
        </div>
    </div>
</template>
<script>
    export default {

        props:{
            user:{
                type: Object,
                required: true,
            }
        },

        data(){
            return {
                avatar: this.user.avatar,
            }
        },

        methods: {

            onLoad(avatar) {
                this.persist(avatar.file);
            },

            persist(avatar) {
                let data = new FormData();
                data.append('avatar', avatar);
                App.request().post(`/account/${this.user.slug}/avatar`, data).then(response => {
                    this.avatar = response.data.avatar;
                    Toast.success('Your picture was uploaded sucessfully!')
                }).catch(errors => {
                    Alert.error(errors.response.data.message)
                });
            }
        }
    }
</script>
